<template>
    <!--
        Spatie honeypot trap. Hidden from real users but present in the DOM so
        form-filling bots populate it. The values are bound to the store and are
        included in axios payloads (and submitted natively inside <form> tags),
        where the ProtectAgainstSpam middleware rejects any non-empty name field.
    -->
    <div
        v-if="honeypot && honeypot.enabled"
        :id="`${honeypot.nameFieldName}_wrap`"
        style="display:none;"
        aria-hidden="true"
    >
        <input
            type="text"
            :name="honeypot.nameFieldName"
            :id="honeypot.nameFieldName"
            v-model="portalContentAndDesignStore.honeypotFormData.name"
            tabindex="-1"
            autocomplete="off"
        />
        <input
            type="text"
            :name="honeypot.validFromFieldName"
            v-model="portalContentAndDesignStore.honeypotFormData.validFrom"
            tabindex="-1"
            autocomplete="off"
        />
    </div>
</template>

<script setup>
import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const honeypot = computed(() => portalContentAndDesignStore.honeypotSettings);
</script>
